<template>
	<div class="item">

		<div class="cells">
			<div class="cell-image">
				<div class="img"><img :src="thumb"/></div>
			</div>
			<div class="cell-title" v-text="title"/>
			<div class="cell-price" v-text="''"/>
			<div class="cell-total" v-text="price"/>
			<div class="cell-remove" v-if="type === 'cart'">
				<a class="icon" @click="remove" v-html="require('@/assets/icons/times-regular.svg')"/>
			</div>
		</div>

		<div class="variants">
			<variant v-for="item in line_items" :key="item.id" v-bind="[item, {type}]"/>
		</div>

	</div>
</template>

<script>
import {price, thumb} from "@/modules/utils";
import variant from "./variant.vue";

export default {
	components: {variant},
	props: {
		id: {type: Number, required: true},
		type: {type: String, required: true},
		image: {type: String, required: false},
		title: {type: String, required: true},
		line_items: {type: Array, required: true}
	},
	computed: {
		quantity: (t) => t.line_items.length,
		price: (t) => price(t.line_items.reduce((sum, x) => sum + x.total_price, 0)),
		thumb: (t) => thumb({url: t.image, size: "128"})
	},
	methods: {
		remove() {
			this.$store.dispatch("cart/removeProduct", {productId: this.id});
		}
	}
};
</script>
<style lang="scss" scoped>
.item {
	margin-bottom: 0.5em;
	border-bottom: 1px solid #D2D6DA;

	&:last-child {
		border-bottom: 0;
	}

	.cells {
		.cell {
			&-image {
				width: 200px;

				.img {
					background-color: $white1;
					$s: 80px;
					width: $s;
					height: $s;

					display: flex;
					align-items: center;
					justify-content: center;
					padding: 0.5em
				}
			}
			&-title {
				font-size: 21px;
				font-weight: 500;
			}
			&-total {
				font-size: 21px;
				font-weight: 500;
			}
			&-remove {
				.icon {
					/deep/ svg {
						$s: 15px;
						width: $s;
						height: $s;
					}
				}
			}
		}
	}

	.variants {
		margin-top: -2em;
		margin-bottom: 1em;
	}
}
</style>
